import { Component, HostListener, Inject, OnInit, TemplateRef, ViewChild, ViewContainerRef } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialog } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { ApiService } from 'src/app/services/api.service';
import { OPERATORS } from 'src/app/services/constants';
import { DataService } from 'src/app/services/data.service';
import { LeafletFeasibilityPreviewComponent } from './leaflet-feasibility-preview/leaflet-feasibility-preview.component';
import { UtilsService } from 'src/app/services/utils.service';
import { Overlay,OverlayRef,OverlayPositionBuilder } from '@angular/cdk/overlay';
import { TemplatePortal } from '@angular/cdk/portal';


@Component({
  selector: 'app-feasibility',
  templateUrl: './feasibility.component.html',
  styleUrls: ['./feasibility.component.scss']
})
export class FeasibilityComponent implements OnInit {
  inputValue: number | string = '';
  @ViewChild('preferenceInput') preferenceInput: any;
  @ViewChild('tooltipTemplate') tooltipTemplate!: TemplateRef<any>;

  dataSource = new MatTableDataSource<any>();
  enteredPreferences: { [key: string]: number } = {};

  displayedColumns: string[] = [ 'captureStart', 'captureEnd',
];
  sensorDetails: any;
  message: any;
  disable: boolean = true;
  SAR: boolean = true;
  load: boolean = true;
  OPERATORS: any;
  feasibilityId: any;
  cancel: boolean = false;
  enabled: boolean;
  loadMessage: string;
  singleInput: boolean = true;
  metaDataTooltip: any;
  darkTheme: boolean;
  tooltipImagePath: string;
  timezone: string;
  hideContent : boolean;
  overlayRef: OverlayRef | null = null;
  operatorDisplayName: string;
 

  constructor(private matdialog: MatDialog, public dialogRef: MatDialogRef<FeasibilityComponent>,
    private apiService: ApiService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private localStorageService: DataService,
    private utilsService: UtilsService,
   private overlay: Overlay,
    private vcr: ViewContainerRef,
    private positionBuilder: OverlayPositionBuilder) {
      this.OPERATORS = OPERATORS;
      this.localStorageService.darkTheme.subscribe((newValue) => {
        this.darkTheme = newValue;

        this.tooltipImagePath = this.darkTheme ? '../../../assets/images/union-dark.svg' : '../../../assets/images/union.svg';
      });
      this.timezone = data?.timezone;
  }

  @HostListener('input', ['$event'])
  onInputChange(event: Event): void {
    const input = event.target as HTMLInputElement;
    const inputValue = input.value;
    // Replace non-numeric characters with an empty string
    const numericValue = inputValue.replace(/[^0-9]/g, '');
    // Limit to a maximum of 2 digits
    input.value = numericValue.slice(0, 2);
  }

  ngOnInit(): void {
    this.operatorDisplayName = ((this.data?.currentUser?.obfuscated ? this.data?.row?.obfuscateName : this.data?.row?.displayName) || '') + ' ' + (this.data?.row?.sensor || '');
    if (this.data?.task) {
      this.cancel = true;
      this.load = false;
      for (const request of this.data?.task.request) {
        if (request?.axelOrderedListJson) {
          const currentTime = new Date();
          const sixteenHoursAhead = new Date(currentTime);
          sixteenHoursAhead.setHours(currentTime.getHours() + 16);
          const filteredArray = request?.axelOrderedListJson.filter(item => {
            const captureStartTime = new Date(item.captureStart);
            return captureStartTime > sixteenHoursAhead;
          });
          this.dataSource = new MatTableDataSource<any>(filteredArray);               
         }
      }
      this.displayedColumns = [ 'captureStart', 'captureEnd', 'cancel'];
      
    } else {
      this.cancel = false;
      this.sensorDetails = this.data.row;
      this.load = true;
      this.feasibilityId = this.data.row?.feasibilityId;
      this.getFeasibility(this.feasibilityId);
      if (this.data.row?.operatorKey === this.OPERATORS.CAPELLA || this.data.row?.operatorKey === this.OPERATORS.SATELLOGIC || 
        this.data.row?.operatorKey === this.OPERATORS.UMBRA || this.data.row?.operatorKey === OPERATORS.BLACKSKY 
        || this.data.row?.operatorKey === OPERATORS.ESPER || (this.data.row?.operatorKey === OPERATORS.ECURS && (this.data.row?.sensortype === "InSAR" || this.data.row?.sensortype === "SAR"))
        || this.data.row?.operatorKey === OPERATORS.AZISTA) {
        this.singleInput = true;
      } else {
        this.singleInput = false;
      }
      if (this.data.row?.operatorKey === this.OPERATORS.CAPELLA) {
       this.SAR = true;
       this.displayedColumns = [ 'captureStart', 'captureEnd','orbital', 'preview', 'preference',];
      } else {   
        this.SAR = false;
        this.displayedColumns = [ 'captureStart', 'captureEnd', 'preference'];
      }
    }
  }

  getFeasibility(feasibilityId: any) {
    let shouldRetry = true;
    this.loadMessage = 'Identifying feasibilities...';
    this.apiService.getFeasibilities(this.data.user, feasibilityId, this.data.taskid, this.sensorDetails).subscribe(
      (result: any) => {        
        if (result?.msg === 'Success') {
          shouldRetry = false;
          if (result.result?.length > 0) {
            this.load = false;
            for (const [idx, data] of result.result.entries()) {
              if (idx === 0) {
               data.sensorName = ((this.data?.currentUser?.obfuscated && this.sensorDetails.obfuscateName) ? this.sensorDetails.obfuscateName : this.sensorDetails.name) + ' ' + this.sensorDetails.sensor;
               data.sensorid = data?.sensorId;
               data.lookAngles = JSON.stringify(data?.lookAngle);
              }
              data.sensorNameToggle = ((this.data?.currentUser?.obfuscated && this.sensorDetails.obfuscateName) ? this.sensorDetails.obfuscateName : this.sensorDetails.name) + ' ' + this.sensorDetails.sensor;
              data.opportunityid = data?.opportunityID;
              data.preference = null;
              data.orbital = data?.orbitalDirection;
             }
             this.dataSource = new MatTableDataSource<any>(result.result); 
          } else {
            this.loadMessage = 'Sorry, no opportunities are available for the selected time of interest (TOI). Please change the TOI and try again.';
          }              
        } else {
          this.feasibilityId = result?.result[0]?.feasibilityId;          
          setTimeout(() => {
            if (shouldRetry) {
              this.getFeasibility(this.feasibilityId);
            }
          }, 60000);
        }
      },
      (error) => {
        // Handle the error or retry if needed
      }
    );   
  }

  getTooltipText(element): string {
    let tooltipText = '';    
    if (element?.satelliteName) {
      tooltipText += 'Satellite Name: ' + element.satelliteName + '\n';
    }
    tooltipText += 'Metadata: ' + JSON.stringify(element.metadata);
    return tooltipText;
  }

  onNoClick(): void {
    if (this.data.row?.operatorKey === this.OPERATORS.CAPELLA) {
      this.dialogRef.close(this.dataSource.data);
    } else
    this.dialogRef.close('close');
  }

  OpenPopup(element: any) {
    this.matdialog.open(LeafletFeasibilityPreviewComponent, {
      width: '50%', data: { taskid: this.data.taskList.id, taskname: this.data.taskList.taskname, target: this.data.taskList.target,
      opportunity: element },
      backdropClass: 'blurred',
      disableClose: true
    });
  }

  // Function to handle input click and set the value to '1' while clearing the previous input
  handleInputClick(input: any, element: any) {
    if (this.preferenceInput !== input) {
      // Clear the previous input
      this.preferenceInput.value = '';
      // Set the current input as active
      this.preferenceInput = input;
    }
    this.dataSource.data.forEach((data) => {
      data.preference = '';
    });
    // Set the input value to '1'
    input.value = '1';
    // Update the element's preference value
    element.preference = 1;
    this.disable = false;
  }

  // Function to allow only '1' to be entered in the input
  handleKeyDown(event: any) {
    const allowedKeyCodes = ['Numpad1', 'Digit1', 'NumpadArrowUp', 'NumpadArrowDown']; // Add other key codes as needed
    const inputValue = event.target.value;
    if (!allowedKeyCodes.includes(event.code) || inputValue !== '1') {
      event.preventDefault(); // Prevent input of any other key
    }
  }

  assignPreferences() {
    this.dataSource.data.sort((a, b) => new Date(a.capture).getTime() - new Date(b.capture).getTime());
    const existingPreferences = new Set();
    let previousPreference = null;
    
    for (const row of this.dataSource.data) {
      let validOrder = false;
      this.message = '';
      if (row.preference !== null && row.preference !== '') {
        // Remove leading zeros using a regular expression
        // row.preference = row.preference.replace(/^0+/, '');
        // Ensure it's a single-digit integer (0-9)
        const parsedValue = parseInt(row.preference, 10);
        if (!isNaN(parsedValue) && parsedValue >= 0 && parsedValue <= 9) {
          // Update the preference value with the trimmed, single-digit value
          row.preference = parsedValue.toString();
        }
      }
      if (row.preference !== null && row.preference > 0) {        
        if (existingPreferences.has(row.preference)) {          
          validOrder = true;
          this.message = 'This preference has already been entered.';
        } else if (row.preference > this.dataSource.data.length) {          
          validOrder = true;
          this.message = 'Max ' + this.dataSource.data.length + ' opportunities are available';
        } else if (previousPreference !== null && parseInt(row.preference) <= parseInt(previousPreference)) {
          validOrder = true;
          this.message = 'Enter preferences in ascending order';
        } else {
          validOrder = false;
          this.message = '';
        }
        existingPreferences.add(row.preference);
        previousPreference = row.preference;
      }
      else if (row.preference !== null && row.preference === '0') {
        validOrder = true;
        this.message = ' 0 preference not allowed';
      } else {
        validOrder = false;
        this.message = '';
      }
      row.validPreferenceOrder = validOrder;
      row.error = this.message;
  }

    const hasInvalidPreference = this.dataSource.data.some(row => row.validPreferenceOrder);
    const enteredRows = this.dataSource.data.filter(row => (row.preference > 0));

    if (hasInvalidPreference && enteredRows?.length > 0) {
      this.disable = true;
    } else if (enteredRows?.length === 0) {
      this.disable = true;
    } else this.disable = false;

  }

  save() {
    const enteredRows = this.dataSource.data.filter(row => (row.preference > 0));
    this.dialogRef.close(enteredRows);
  }

  onCheck() {
    this.enabled = false;
    const enteredRows = this.dataSource.data.filter(row => (row.cancel));
    if (enteredRows?.length > 0) {
     this.enabled = true;
    } else this.enabled = false;
  }

  cancelOpportunity() { 
    this.enabled = false;   
    const enteredRows = this.dataSource.data.filter(row => (row.cancel));
    this.apiService.cancelFeasibility(enteredRows, this.data.taskBody).subscribe(
      (result: any) => {
        this.dialogRef.close(result);
      });
  }

  getMetadata(trigger: HTMLElement, elementData: any) {
    if (this.overlayRef) return;

    this.metaDataTooltip = elementData?.metadata;

    const positionStrategy = this.positionBuilder
      .flexibleConnectedTo(trigger)
      .withFlexibleDimensions(false)
      .withPush(false)
      .withScrollableContainers([]) 
      .withPositions([
        {
          originX: 'end',      
          originY: 'bottom',    
          overlayX: 'start',    
          overlayY: 'top'       
        },
        {
          originX: 'start',     
          originY: 'bottom',
          overlayX: 'end',      
          overlayY: 'top'
        },
        {
          originX: 'end',
          originY: 'top',
          overlayX: 'start',
          overlayY: 'bottom'
        },
        {
          originX: 'start',
          originY: 'top',
          overlayX: 'end',
          overlayY: 'bottom'
        }
      ]);
    this.overlayRef = this.overlay.create({
      positionStrategy,
      scrollStrategy: this.overlay.scrollStrategies.reposition(),
      hasBackdrop: false,
      panelClass: 'custom-overlay-panel'
    });

    const portal = new TemplatePortal(this.tooltipTemplate, this.vcr);
    this.overlayRef.attach(portal);
    
  }

  onMouseLeave() {
    if (this.overlayRef) {
      this.overlayRef.detach();
      this.overlayRef = null;
    }
  }

  formatDate(dateTime: string) {
    if (!dateTime) return null;
    
    return this.timezone === 'Local Time' 
      ? this.utilsService.convertUtcToLocal(dateTime, this.data?.currentUser) 
      : dateTime;
  }

}
